<template>
  <div class="what" id="services">
    <div class="container">
      <div class="what__wrapper">
        <h2 class="what__title">What We Offer to <span>Accelerate Your Growth</span></h2>
        <p class="what__subtitle">Discover a full suite of marketing services designed to build, promote, and elevate your brand in a competitive digital world</p>
        <div class="what__grid">
          <div
              class="what__item"
              v-for="(item, idx) in items"
              :key="idx"
          >
            <img :src="item.icon" alt="">
            <p class="what__item-title">{{ item.title }}</p>
            <p class="what__item-text">{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const items = [
  {
    icon: "/whatImage1.svg",
    title: "Strategic Planning & Insights",
    text: "We create tailored marketing strategies driven by industry analysis, competitor research, and audience segmentation to help your brand grow smarter."
  },
  {
    icon: "/whatImage2.svg",
    title: "Digital Growth Solutions",
    text: "Through expert SEO, PPC, digital advertising solutions, we help you attract, engage, and convert the right audience across multiple platforms."
  },
  {
    icon: "/whatImage3.svg",
    title: "Content Creation Services",
    text: "We create impactful content from articles and videos to infographics and social posts designed to capture attention, build trust, and drive action."
  },
  {
    icon: "/whatImage4.svg",
    title: "Brand Identity Development",
    text: "We define and sharpen your brand’s unique voice, message, and visuals to build strong, lasting impressions across every customer interaction."
  },
  {
    icon: "/whatImage5.svg",
    title: "Social Media Management",
    text: "We take charge of your social media presence, delivering consistent content, fostering engagement, maintaining a positive brand reputation."
  },
  {
    icon: "/whatImage6.svg",
    title: "Analytics & Optimization",
    text: "By continuously tracking campaign results, we turn data into actionable insights that fuel smarter strategies and deliver ongoing growth."
  }
]
</script>

<style lang="scss" scoped>
.what {
  padding-top: 50px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    color: #2F327D;
    font-size: 28px;
    font-weight: 700;
    line-height: 180%;

    & span {
      color: #F48C06;
    }
  }

  &__subtitle {
    width: 850px;
    color: #696984;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 180%;
  }

  &__grid {
    width: 100%;
    margin-top: 100px;
    display: grid;
    grid-template-columns: repeat(3, 380px);
    justify-content: space-between;
    row-gap: 100px;
  }

  &__item {
    border-radius: 20px;
    background-color: $white;
    box-shadow: 0 10px 60px 0 rgba(38, 45, 118, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 36px;
    padding: 0 45px 35px 45px;

    & img {
      margin-top: -50px;
    }

    &-title {
      margin-top: 20px;
      color: #2F327D;
      text-align: center;
      font-size: 26px;
      font-weight: 500;
    }

    &-text {
      color: #696984;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      line-height: 180%;
    }
  }
}

@media (max-width: 1300px) {
  .what {
    &__grid {
      grid-template-columns: repeat(3, 300px);
    }

    &__item {
      padding: 0 25px 35px 25px;

      &-title {
        margin-top: 0;
        font-size: 20px;
      }

      &-text {
        font-size: 16px;
      }
    }
  }
}

@media (max-width: 1300px) {
  .what {
    &__grid {
      grid-template-columns: repeat(2, 300px);
    }
  }
}

@media (max-width: 850px) {
  .what {
    &__title {
      text-align: center;
    }

    &__subtitle {
      width: 100%;
    }
  }
}

@media (max-width: 650px) {
  .what {
    &__title {
      font-size: 22px;
    }

    &__subtitle {
      font-size: 16px;
    }

    &__grid {
      grid-template-columns: repeat(1, 300px);
      align-items: center;
      justify-content: center;
    }
  }
}
</style>